<template>
  <div>

    <h1>Mis consultas</h1>
    <p class="main-description">
      Agenda una consulta conmigo y analizaremos tu carta astral durante una sesión presencial
      o virtual, en la que te ayudaré a definir las acciones futuras adecuadas para alcanzar el éxito.
    </p>

    <v-row>
      <v-col sm="">
        <v-card
            v-if="form">
          <v-form v-model="valid"
                  ref="form"
                  :lazy-validation="lazy"
                  class="ma-2">
            <v-row>
              <v-col class="" sm="8">
                <label for="">Fecha de la consulta</label>
                <br/>
                <v-datetime-picker :min="min" v-model="picker">
                  <template slot="actions" slot-scope="{ parent }">
                    <v-btn text color="primary darken-1" @click="parent.okHandler">OK</v-btn>
                  </template>
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-timer</v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="" sm="8">

                <label for="">Motivo de consulta</label>
                <br/>
                <v-select
                    v-model="value"
                    :items="items"
                    :rules="[v => !!v || 'Seleccione un motivo']"
                    label=""
                    @change="otherInput"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="otherSelect">
              <v-col sm="6">
                <v-textarea
                    outlined
                    name="input-7-4"
                    label="Cuéntame el motivo de su consulta"
                    v-model="reason"
                    :rules="nameRules"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12">
                <v-btn class="primary" large :disabled="!valid" @click="validate(), getDDMMYY(picker)">
                  Solicitar consulta
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="!form">
      <v-col>
        <v-card>
          <div class="title">Datos de su consulta</div>
          <div class="details">
            <dd>Fecha: {{ ddmmyy }} horas</dd>
            <dd>Motivo: {{ value }}</dd>
            <dd v-if="value === 'Otro'">Detalle: {{ reason }}</dd>
            <dd>Costo: {{ cost }}</dd>
          </div>
          <div class="ctn-btns">
            <v-btn outlined color="primary" class=""  :to="{name: 'Appoinments'}">Cancelar</v-btn>
            <v-btn class="" color="primary"  @click="dialog = true">Nueva consulta</v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          max-width="650"
      >
        <v-card rounded class="pa-3">
          <v-row>
            <v-col class="text-end">
              <v-btn icon color="red" @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <div class="ctn-img text-center">
            <img src="../assets/logo.png"/>
          </div>
          <v-card-title>
          </v-card-title>
          <v-card-text>
            <p class="text-h6 text-center">Hemos recibido tu solicitud. <br> En un plazo de 48 horas hábiles enviaremos
              un correo confirmando el día y la hora para tu consulta.</p>
          </v-card-text>
          <v-row class="text-center">
            <v-col>
              <v-btn color="primary" large @click="sendCon">Continuar</v-btn>
            </v-col>
          </v-row>

        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";

export default {
  name: 'NewConsult',
  data() {
    return {
      picker: new Date(),
      min: new Date(),
      items: ['Personal', 'Negocio', 'Otro'],
      value: null,
      otherSelect: false,
      valid: false,
      lazy: false,
      reason: '',
      nameRules: [
        v => !!v || 'Motivo es requerido',
      ],
      form: true,
      cost: 'US$ 700',
      dialog: false,
      ddmmyy: ''
    }
  },
  methods: {
    otherInput() {
      if (this.value === 'Otro') {
        this.otherSelect = true
      } else {
        this.otherSelect = false
      }
    },
    validate() {
      this.$refs.form.validate()
      this.form = false;
    },
    getDDMMYY(day) {
      let arrayPicker = day.toISOString().split(['-']);
      let hour = 0;
      if (parseInt(arrayPicker[2].substr(-13, 2)) >= 0 && arrayPicker[2].substr(-13, 2) <= 4) {
        hour = parseInt(arrayPicker[2].substr(-13, 2)) + 19;
      } else {
        hour = parseInt(arrayPicker[2].substr(-13, 2)) - 5;
      }

      if (hour >= 10) {
        hour
      } else {
        hour = `0${hour}`
      }

      this.ddmmyy = `${arrayPicker[0]}-${arrayPicker[1]}-${arrayPicker[2].substr(-20, 2)} ${hour}${arrayPicker[2].substr(-11, 3)}`;
      this.ddmmyy = `${arrayPicker[0]}-${arrayPicker[1]}-${arrayPicker[2].substr(-20, 2)} ${hour}${arrayPicker[2].substr(-11, 3)}`
    },
    async sendCon() {

      let reasonDetails = '';
      if (this.reason === ''){
        reasonDetails = this.value;
      } else {
        reasonDetails = `${this.value} - ${this.reason}`
      }

      let dataSend = {
        'reason': reasonDetails,
        'date': `${this.ddmmyy}:00`
      }

      try {
        await axios.post('personal-consultation', dataSend);
        await router.push({name: 'Appoinments'});
      } catch (error) {
        console.log(error);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  .ctn-btns {
    margin-top: 30px;
    margin-bottom: 10px;
  }
  ::v-deep .v-btn {
    text-transform: unset;
    font-family: "Avenir";
    letter-spacing: normal;
    font-size: 14px;
    height: 40px;
    width: 160px;
    margin-top: 5px;
    border-radius: 7px;
    margin-right: 20px;
    letter-spacing: 0 !important;
    text-transform: none !important;
  }
  .v-card {
    padding: 30px;
  }
  .title {
    font-size: 18px !important;
    font-weight: 800;
    margin-bottom: 22px;
    color: #656565;
  }
  .details {
    color: #656565;
  }
  dd {
    line-height: 22px;
    font-size: 16px;
    font-weight: 200;
    margin-bottom: 12px;
  }
  ::v-deep .v-input {
    width: 250px;
		.v-messages__message {
			padding-top: 3px;
		}
    &.v-input--is-disabled {
      .v-input__slot::before {
        display: none;
      }

      .v-input__append-inner {
        display: none;
      }
    }

    .v-input__slot {
      margin-bottom: 0;

      .v-text-field__slot input {
        color: #656565;
      }
    }
  }
</style>
